<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'lefttabrightcontent',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="0">
        <a-col   :lg="{span:3}" :md="{span:3}" :sm="{span:0}" :style="{heigth:imgh+'px'}" style="overflow:hidden;" class="flex-column align-center justify-center padding-left">
            <div @click="moveTo(i)" :class="i==def?'active':''" class="bg-img margin-bottom  img-nav" :style="{background:('url('+addip(item.pic)+')'),height:navh+'px'}" v-for="(item,i) in data.child" :key="i" ></div>
        </a-col>
         <a-col :lg="{span:21}" :md="{span:20}" :sm="{span:24}">
            <a-carousel ref="carousel" :dots="false" :afterChange="change" class="radius box-shadow-lg img-ccarousel-box" :autoplay="true" >
            <div v-for="(item,i) in data.child" :key="i" >
              <div class="bg-img content-box   text-white" :style="{background:('url('+addip(item.pic)+')'),height:imgh+'px'}">
                <div v-if="data.showtitle>0" class="content-title auto-container flex-column justify-end">
                  <h2>{{ item.name }}</h2>
                  <h4 v-if="item.sub">{{ item.sub }}</h4>
                  <h3 class="margin-tb-lg" v-if="item.url"><a :href="item.url" class="btn-primary"   size="large" >
                    详情 <ArrowRightOutlined />
                  </a></h3>
                </div>
              </div>
            </div>
          </a-carousel>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="lefttabrightcontent">
import {defineComponent,defineProps, onMounted ,ref} from 'vue'
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
const navh=ref<Number>(128)
const imgh=ref<Number>(480)
const def=ref<Number>(0)
const carousel=ref()
onMounted(()=>{
  let dom=document.querySelector('.lefttabrightcontent .img-nav')
  if(dom){
    navh.value=dom.offsetWidth*9/16
  }
  let dom1=document.querySelector('.lefttabrightcontent .img-ccarousel-box')
  if(dom1){
    imgh.value=dom1.offsetWidth*9/16
  }
})
const change=(i:Number)=>{
  def.value=i
}
const moveTo=(i:Number)=>{
  def.value=i
  carousel.value.goTo(i,false)
}
</script>
<style lang="less">
@import '@/style/main.less';
  .lefttabrightcontent{
    .img-nav{width: 100%;cursor: pointer;border-radius:  10px 0 0 10px  ;border-right: 6px solid transparent;transition: all .2s linear;}
    .img-nav:hover ,.img-nav.active{box-shadow:@black-opacity-50 0 0 24px ;border-right: 6px solid @primary;animation: x3d .5s linear;}
    .bg-img.content-box{height: 480px;}
    .content-box{display: flex;align-items: center;justify-content: center;text-align: center;color:@white;}
  }
@keyframes x3d{
  0%{transform:rotateZ(0deg) ;}
  25%{transform:rotateZ(10deg) ;}
  50%{transform:rotateZ(0deg) ;}
  75%{transform:rotateZ(-10deg) ;}
  100%{transform:rotateZ(0deg) ;}
}
</style>
